<template>
  <div class="ls-change-component2">
    <template>
      <a-date-picker
        :placeholder="title"
        v-if="comType==='date'"
        valueFormat="YYYY-MM-DD"
        :value="value"
        :allowClear="true"
        @change="dateChange"
        @openChange="dateOpenChange"
      />
      <a-input
        :placeholder="title"
        v-else
        :value="value"
        :allowClear="true"
        @change="inputChange"
        @blur="inputBlur"
        ref="input"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'Ls-change-component2',
  props: {
    icon: {
      type: String,
      default: 'icon-lsmy-sousou'
    },
    title: {
      type: String
    },
    value: {
      type: String
    },
    comType: {
      type: String,
      default: 'input'
    }
  },
  data () {
    return {
      edit: false
    }
  },
  methods: {
    changeEdit () {
      this.edit = true
      if (this.comType === 'input') {
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      }
    },
    inputChange (e) {
      this.$emit('input', e.target.value)
      this.$emit('change', e)
    },
    inputBlur (e) {
      this.edit = false
      this.$emit('blur', e)
    },
    dateChange (date, dateString) {
      this.$emit('input', dateString)
      this.$emit('change', dateString)
    },
    dateOpenChange (open) {
      if (!open) {
        this.$emit('blur', this.value)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ls-change-component2 {
  /deep/.ant-input {
    &::placeholder {
      color: #474747;
    }
  }
}
</style>
